import Vue from 'vue'
import store from '@/store/store'
import moment from 'moment'
import $f from '@/modules/fptai/filters/filters'

const $utils = {
    getHostSource () {
        let protocol = window.location.protocol
        let hostname = window.location.hostname
        let port = window.location.port ? ':' + window.location.port : ''
        return protocol + '//' + hostname + port
    },
    copyToClipboard (str, notificationText) {
        const el = document.createElement('textarea')
        el.value = str
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        if (notificationText !== null && notificationText !== undefined) {
            window.vueapp.$appService.toastSuccess(notificationText)
        }
    },
    getDataClipboard () {
        return navigator.clipboard.readText()
    },
    isMobile () {
        return window.vueapp.$vuetify.breakpoint.name === 'xs'
    },
    isTablet () {
        return (
            window.vueapp.$vuetify.breakpoint.name === 'sm' ||
            window.vueapp.$vuetify.breakpoint.name === 'md'
        )
    },
    isTouchDevice () {
        return window.vueapp.$vuetify.breakpoint.mdAndDown
    },
    isPC () {
        return (
            window.vueapp.$vuetify.breakpoint.name === 'lg' ||
            window.vueapp.$vuetify.breakpoint.name === 'xl'
        )
    },
    isNotMobile () {
        return !this.isMobile()
    },
    buildQuery (url, params) {
        url = url || ''
        if (params) {
            let query = []
            for (let key in params) {
                if (params.hasOwnProperty(key) && params[key] && params[key] !== '' && params[key] !== null) {
                    query.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
                }
            }
            if (query.length) {
                url.indexOf('?') > -1 ? url += '&' + query.join('&') : url += '?' + query.join('&')
            }
        }
        return url
    },
    getLastUrlSegment (url) {
        if (!url) {
            return ''
        }
        if (url.slice(-1) === '/') {
            url = url.substring(0, url.length - 1)
        }
        url = url.substr(url.lastIndexOf('/') + 1)
        return url
    },
    nonAccentVietnamese (str) {
        str = str.trim().toLowerCase()
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
        str = str.replace(/đ/g, 'd')
        str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '')
        str = str.replace(/\u02C6|\u0306|\u031B/g, '')
        return str
    },
    saveFile (data, filename, fileExtension) {
        let fileURL = window.URL.createObjectURL(new Blob([data]))
        let fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', filename + '' + fileExtension)
        document.body.appendChild(fileLink)
        fileLink.click()
        fileLink.parentNode.removeChild(fileLink)
    },
    reFormatHeaderTable (headers) {
        return headers.map(header => {
            let key = header.value
            if (key === 'status' || key === 'record_url' || key === 'history') {
                header = Object.assign({}, header, {
                    id: header.value,
                    type: 'custom'
                })
            } else if (key === '$conversation_flow') {
                header = Object.assign({}, header, {
                    id: 'conversation_flow',
                    type: 'custom'
                })
            } else if (key === 'pickup_date' || key === 'pickup_time' || key === 'start_time' || key === 'end_time') {
                header = Object.assign({}, header, {
                    id: header.value,
                    type: 'datetime'
                })
            } else if (key === 'start_date' || key === 'end_date') {
                header = Object.assign({}, header, {
                    id: header.value,
                    type: 'date'
                })
            }
            return header
        })
    },
    getStatusColor (status) {
        let defaultColor = '#87bf40'
        let colorMap = {
            ANSWERED: '#87bf40',
            WAITING: '#919191',
            RUNNING: '#0052CC',
            FINISHED: '#42be80',
            COMPLETE: '#42be80',
            CANCELED: '#b7bf40',
            DONE: '#92c353',
            INVALID: '#bf6840',
            PAUSE: '#ffb100',
            ATTEMPTED_CONNECTED: '#87bf40',
            ATTEMPTED_UNCONNECTED: '#ffa500',
            IN_PROGRESS: '#4097bf',
            NOT_ATTEMPTED: '#1980ef',
            NA: '#000',
            CONNECTED: '#87bf40',
            UNCONNECTED: '#ffa500',
            TO_DO: '#8A97AA',
            CLOSE: '#c4314b',
            ERROR: '#e74c3c',
            TIME_OUT:'#b7bf40'
        }
        status = status.toUpperCase()
        status = status.replace(' ', '_')
        return colorMap[status] ? colorMap[status] : defaultColor
    },
    colorSamples: [
        '#ffb100',
        '#42be80',
        '#379cfd',
        '#40bf87',
        '#b7bf40',
        '#4840bf',
        '#bf6840',
        '#4097bf',
        '#58bf40',
        '#a740bf',
        '#40bf4c'
    ],
    convertBlobToDataURL (blob) {
        return new Promise((resolve, reject) => {
            let fileReader = new FileReader()
            fileReader.readAsDataURL(blob)
            fileReader.onloadend = function () {
                resolve(fileReader.result)
            }
        })
    },
    isScrolledIntoView (elementId, parentId, shouldScrollIntoView) {
        let element = document.getElementById(elementId)
        let parent = document.getElementById(parentId)
        let elementRect = element.getBoundingClientRect()
        let parentRect = parent.getBoundingClientRect()
        let diff_x = parentRect.x + parentRect.width - elementRect.x - elementRect.width
        let diff_y = parentRect.y + parentRect.height - elementRect.y - elementRect.height
        let isScrolledIntoView = diff_x >= 0 && diff_y >= 0
        if (!isScrolledIntoView && shouldScrollIntoView) {
            parent.scrollBy(
                diff_x < 0 ? 20 - diff_x : 0,
                diff_y < 0 ? 20 - diff_y : 0
            )
        }
        return isScrolledIntoView
    },
    limitStringLength (str, max) {
        if (str.length > max) {
            return str.substring(0, max - 3) + '...'
        }
        return str
    },
    cloneObject (item) {
        return JSON.parse(JSON.stringify(item))
    },
    downloadJSON (data, fileName) {
        let a = document.createElement('a')
        a.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data))
        // a.href = String.fromCharCode(parseInt(a.href, 16))
        a.setAttribute('download', fileName + '.json')
        a.click()
        a.remove()
    },
    downloadFileFromBlob (data, fileName) {
        const blob = new Blob([data])
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        anchor.click()
        window.URL.revokeObjectURL(url)
    },
    getFileNameFromUrl (url) {
        let filename = null
        try {
            let lastIndexOf = url.lastIndexOf('/')
            if (lastIndexOf >= 0) {
                filename = url.substring(lastIndexOf + 1)
            }
        } catch (e) {
        }
        if (!filename) {
            filename = 'download'
        }
        return filename
    },
    downloadFileFromUrl (url, filename) {
        // in case current domain is difference from file domain
        // switch to use downloadFileFromUrlAsBlob
        // follow this link for more info:
        // https://stackoverflow.com/questions/23872902/chrome-download-attribute-not-working
        if (!url) {
            return
        }
        if (!filename) {
            filename = this.getFileNameFromUrl(url)
        }
        let a = document.createElement('a')
        a.href = url
        a.setAttribute('download', filename)
        a.click()
    },
    canEditCampaign () {
        let user = store.state.user
        // system admin
        if (user.profile.roles.includes('admin')) {
            return true
        }
        // campaign owner
        let campaign = store.state.campaign.campaign
        if (campaign.owner === user.profile.email) {
            return true
        }
        // campaign role admin
        return campaign.permissions.includes('admin')
    },
    convertDateStringToTimestamp (dateStr) { // dateStr: 'YYYY-MM-DD HH:mm:ss'
        const [dateRelated, timeRelated] = dateStr.split(' ')
        const [year, month, day] = dateRelated.split('-')
        const [hours, minutes, seconds] = timeRelated.split(':')

        const datetime = new Date(+year, month - 1, +day, +hours, +minutes, +seconds)
        return datetime.getTime() / 1000
    },
    convertToTimestamp (date, time) {
        let datetime = new Date(`${date} ${time}`.trim())
        return datetime.getTime() / 1000
    },
    convertTimestamp (timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
        let dateArr = new Date(timestamp * 1000)
        if (!dateArr) return null
        let datetime = moment(dateArr).format(format).split(' ')
        return {
            date: datetime[0],
            time: datetime[1]
        }
    },
    convertTimestampToStringFormat (timestamp, format) {
        let dateArr = new Date(timestamp * 1000)
        if (!dateArr) return null
        let datetime = moment(dateArr).format(format)
        return datetime
    },
    getRandomColor () {
        let hex = '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
        if (hex === '#ffffff' || hex.length !== 7) {
            return this.getRandomColor()
        } else {
            return hex
        }
    },
    getAcronymsName (name) {
        let elements = name.split(' ')
        let surname = elements[0]
        let realName = elements[elements.length - 1]
        return (surname.charAt(0) + realName.charAt(0)).toUpperCase()
    },
    convertSnakeToCamel (str) {
        return str.toLowerCase().replace(/([-_][a-z])/g, group =>
            group
                .toUpperCase()
                .replace('-', '')
                .replace('_', '')
        )
    },
    convertSnakeToCapitalize (str) {
        let text = str.toLowerCase().replace(/([-_][a-z])/g, group =>
            group
                .toUpperCase()
                .replace('-', ' ')
                .replace('_', ' ')
        )
        text = text.toLowerCase()
        return text.charAt(0).toUpperCase() + text.slice(1)
    },
    sortPropertiesObject (object) {
        if (!object) {
            return object
        }

        return Object.keys(object).sort().reduce((objEntries, key) => {
            objEntries[key] = object[key]
            return objEntries
        }, {})
    },
    sleep (sleepTime) {
        return new Promise(resolve => setTimeout(resolve, sleepTime))
    },
    isUUID (s) {
        return s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')
    },
    enableTovaAgent(){
        let env = process.env.VUE_APP_ENABLE_TOVA
        return env === "TRUE"
    },
    enableVoiceAgent() {
        let env = process.env.VUE_APP_ENABLE_AGENT
        return env === 'TRUE'
    },
    enableQC() {
        let env = process.env.VUE_APP_ENABLE_QC
        return env === 'TRUE'
    },
    toCamelCase(str) {
        return str
            .replace(/(?:^\w|[^\w\s]|_|\s+\w)/g, (match, index) => index === 0 ? match.toLowerCase() : match.toUpperCase())
            .replace(/\s+/g, '')  // Remove any spaces
    }
}
Vue.prototype.$utils = $utils
export default $utils
